import { createContext, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'

import { Card } from 'antd'

import { api, request } from '../../../util/handlerRequestUtil'
import { isAdmin } from '../../../util/profiles'
import CardsActionPlan from './ActionPlan.Card'
import ListActionPlan from './ActionPlan.List'

export const CustomerActionsPlanContext = createContext({})

const CustomerActionsPlan = ({ customerId }) => {
  const currentUser = useSelector((state) => state.auth.auth)
  const [customer, setCustomer] = useState({})
  const [customerLocations, setCustomerLocations] = useState([])
  const [loadCard, setLoadCard] = useState(false)
  const [filters, setFilters] = useState({})
  const contextValue = {
    customerLocations,
    filters,
    setFilters,
    customerId,
    customer,
    formatAcoesExecutadas,
    formatArea,
    getLocationsByCustomer,
    loadCard,
    setLoadCard
  }

  useEffect(() => {
    load()
  }, [])

  useEffect(() => {
    getLocationsByCustomer()
  }, [filters, loadCard])

  async function load() {
    await fetchCustomer(customerId)
    getLocationsByCustomer()
  }

  async function fetchCustomer(customerId) {
    const customer = await request(api.getCustomer(customerId))
    setCustomer(customer)
  }

  async function getLocationsByCustomer() {
    const locations = await request(api.getLocationsByCustomer(customerId, filters))
    const items = !isAdmin() ? locations.filter((region) => region.regionId === currentUser.memberRegionId) : locations
    setCustomerLocations(items)
  }

  function formatAcoesExecutadas(acoesPlanejadas, acoesExecutadas) {
    if (acoesPlanejadas === 0) {
      return acoesExecutadas + ' (0%)'
    }
    return acoesExecutadas + ' (' + parseInt((100 * acoesExecutadas) / acoesPlanejadas) + '%)'
  }

  function formatArea(area) {
    if (!area) {
      return '0 ha'
    } else {
      return area + ' ha'
    }
  }

  return (
    <CustomerActionsPlanContext.Provider value={contextValue}>
      <Card className="ant-card gx-card ant-card-bordered">
        <CardsActionPlan />
      </Card>
      <ListActionPlan />
    </CustomerActionsPlanContext.Provider>
  )
}

export default CustomerActionsPlan
